import * as Sentry from "@sentry/nextjs";

/**
 * Log an error AND report it to Sentry. Use in caught-and-handled paths (after() tasks,
 * fire-and-forget routes, swallowed catches) that would otherwise end at a console line
 * nobody watches (OBS-1). Sentry no-ops when the DSN is unset.
 */
export function reportError(
  message: string,
  error: unknown,
  extra?: Record<string, unknown>,
): void {
  console.error(message, error);
  Sentry.captureException(error, { extra: { message, ...extra } });
}

/**
 * Report a noteworthy non-exception condition (e.g. every lead recipient filtered out)
 * so it's alertable in Sentry, not just a console line.
 */
export function reportWarning(message: string, extra?: Record<string, unknown>): void {
  console.error(message);
  Sentry.captureMessage(message, { level: "warning", extra });
}
